<template>
  <div id="page-battery-analysis">
    <el-form
      class="search-form"
      ref="searchForm"
      :inline="true"
      :model="searchForm"
      label-width="6em"
    >
      <el-row>
        <el-form-item label="统计时间" required>
          <el-date-picker
            v-model="searchForm.date"
            value-format="timestamp"
            type="date"
            :clearable="false"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="合作商" required>
          <filter-businessline-partner
            required
            :value.sync="searchForm.supplierId"
            :code.sync="supplierCode"
            :businessLine="businessLine"
            @initFetch="fetchData(true)"
          />
        </el-form-item>
        <el-form-item label="城市">
          <filter-businessline-region
            :value.sync="searchForm.regionId"
            :businessLine="businessLine"
          />
        </el-form-item>
        <el-form-item style="float: right;">
          <el-button type="primary" @click="fetchData(true)" :loading="isLoading">查询</el-button>
          <!-- <el-button @click="exportData" :loading="exportLoading" :disabled="isDisableExport">导出</el-button> -->
        </el-form-item>
      </el-row>
    </el-form>
    <!-- 柱状图 -->
    <div
      class="analysis-rate"
      style="width: 80vw;height:400px;"
      :class="[dataRateList.length === 0 ? 'hide-rate' : '']"
    ></div>
    <div
      class="analysis-loss"
      style="width: 80vw;height:400px;"
      :class="[dataLossList.length === 0 ? 'hide-rate' : '']"
    ></div>
  </div>
</template>

<script>
import lxUtils from '@/mixins/lx'
import pagination from '@/mixins/pagination'
import exportData from '@/mixins/exportData'
import { dateFormat } from '@/utils'

import * as echarts from 'echarts/core'
import {
  TooltipComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
} from 'echarts/components'
import { BarChart, LineChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'

echarts.use([
  TooltipComponent,
  GridComponent,
  LegendComponent,
  BarChart,
  CanvasRenderer,
  TitleComponent,
  LineChart,
])
var options

const labelRateMap = {
  averageReplaceUnder20: '20以下换电数',
  averageReplace2040: '20-40换电数',
  averageReplaceOver40: '40以上换电数',
  averageXinzeng20: '新增低电数',
}

const labelLossMap = {
  averageTotalStaffNum: '换电人数',
  averageReplaceNumBy10: '换电量/10',
  sumLowScanCount: '低电扫码数',
  averageTotalScanCountBy10: '总扫码数/10',
}

export default {
  mixins: [pagination, exportData, lxUtils],

  data() {
    return {
      cid: 'c_mobikeops_ebikeBusiness_data_ChangeBatteryinTimeperiod_sacan',
      businessLine: 2,
      isLoading: false,
      dataRateList: [],
      dataLossList: [],
      startDate: Date.now() - 24 * 60 * 60 * 1000,
      supplierCode: this.$route.query.supplierCode,
      searchForm: {
        ...this.$route.query,
      },
      // 导出
      exportFileName: '换电日报',
      exportUrl: 'exportReportData',
      isDisableExport: false,
      pageSize: 25,
    }
  },
  computed: {
    filterParams() {
      const { date, endDate, regionId } = this.searchForm
      return {
        pageId: 'time_period_renew_battery',
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        date: dateFormat(date, 'yyyy-MM-dd'),
        endDate: dateFormat(endDate || date, 'yyyy-MM-dd'),
        supplierCodeList: this.supplierCode ? [this.supplierCode] : [],
        regionIdList: regionId ? [regionId] : [],
      }
    },
    exportParams() {
      const params = {
        ...this.filterParams,
        supplierCodeList: this.filterParams.supplierCodeList.join(','),
        regionIdList: this.filterParams.regionIdList.join(','),
      }
      delete params.pageNo
      delete params.pageSize
      return params
    },
  },
  mounted() {
    this.searchForm.date = this.$route.query.date || this.startDate
    this.initPagination('fetchData', false)
  },
  methods: {
    // 列表
    fetchData(init = false) {
      if (init) this.pageNo = 1
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...this.filterParams,
      }
      if (!this.searchForm.supplierId) {
        this.$message.error('合作商不能为空')
        return
      }
      this.isLoading = true
      this.fetch
        .post('getGenericData', params)
        .then(res => {
          if (res.data) {
            const [lossData = {}, rateData = {}] = res.data || []
            this.dataRateList = rateData.data || []
            let str = ''
            if (this.dataRateList.length === 0) {
              str += '<div>分时段换电与低电占比-暂无数据</div>'
            }
            this.dataLossList = lossData.data || []
            if (this.dataLossList.length === 0) {
              str += '<div class="ui-mt-10">分时换电量与低电流失-暂无数据</div>'
            }
            str &&
              this.$message({
                type: 'warning',
                dangerouslyUseHTMLString: true,
                message: str,
                showClose: true,
              })

            const rateConfig =
              this.chartOptions(
                labelRateMap,
                {
                  series: {
                    stack: 'total',
                  },
                },
                this.dataRateList
              ) || {}
            // 处理折线数据
            let tmpSeries = rateConfig.series || []
            tmpSeries = tmpSeries.map(item => {
              if (item && item.type === 'line') {
                delete item.stack
              }
              return item
            })
            rateConfig.series = tmpSeries
            const LossConfig = this.chartOptions(
              labelLossMap,
              {
                title: '分时换电量与低电流失',
                yAxis: [
                  {
                    name: 'session数',
                    type: 'value',
                    min: 0,
                    position: 'left',
                  },
                  {
                    name: '人数&换电数',
                    type: 'value',
                    min: 0,
                    interval: Math.ceil(35 / 7),
                    position: 'right',
                  },
                ],
              },
              this.dataLossList
            )

            console.log('config:', JSON.stringify(rateConfig))
            this.initCharts(rateConfig, 'analysis-rate')
            this.initCharts(LossConfig, 'analysis-loss')
          } else {
            this.$message({
              type: 'warning',
              dangerouslyUseHTMLString: true,
              message: '暂无数据',
              showClose: true,
            })
          }
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    initCharts(config = options, name) {
      const chartDom =
        document.getElementsByClassName(name) && document.getElementsByClassName(name)[0]
      const myChart = echarts.init(chartDom, 'light')

      config && myChart.setOption(config)
    },

    // 需要处理的Y轴数据
    isNeedCalculate(str = '') {
      if (!str) return false
      const tmpList = ['averageReplaceNumBy10', 'averageTotalScanCountBy10']
      return tmpList.includes(str)
    },

    getYIndex(val) {
      if (!val) return 0
      let res = 0
      switch (val) {
        case 'averageTotalStaffNum':
        case 'averageReplaceNumBy10':
          res = 1
          break
        case 'sumLowScanCount':
        case 'averageTotalScanCountBy10':
          res = 0
          break
        default:
          break
      }
      return res
    },

    getType(val) {
      let res = 'bar'
      const tmpList = ['sumLowScanCount', 'averageTotalScanCountBy10', 'averageXinzeng20']
      res = tmpList.includes(val) ? 'line' : 'bar'
      return res
    },

    /**
     * @description 生成柱状图配置
     * @param {object} labelMap 名称
     * @param {object} configData 处理配置参数
     * @param {array} sourceData 数据来源
     */

    chartOptions(labelMap = {}, configData = {}, sourceData = []) {
      // 横坐标
      const xList = []
      const tmpSeries = []
      const tmpLegend = []

      const defaultOptions = {
        label: {
          show: false,
        },
        emphasis: {
          focus: 'series',
        },
      }
      Object.keys(labelMap).forEach((config, index) => {
        const tmpList = []
        sourceData.forEach((item, subIndex) => {
          if (index === 0) {
            xList.push(subIndex + '')
          }
          if (this.isNeedCalculate(config)) {
            tmpList.push(item[config])
          } else {
            tmpList.push(item[config])
          }
        })
        tmpLegend.push(labelMap[config])
        tmpSeries.push(
          Object.assign(
            {},
            {
              ...defaultOptions,
              data: tmpList,
              name: labelMap[config],
              yAxisIndex: this.getYIndex(config),
              type: this.getType(config),
            },
            { ...configData.series }
          )
        )
      })
      const options = {
        title: {
          text: configData.title || '分时段换电与低电占比',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          data: tmpLegend,
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        yAxis: {
          type: 'value',
          name: '车辆数&换电数',
        },
        xAxis: {
          name: '小时',
          type: 'category',
          data: xList,
          nameLocation: 'center',
          nameGap: '20',
        },
      }
      // 自定义y轴
      if (configData.yAxis) {
        options.yAxis = configData.yAxis
      }
      options.series = tmpSeries
      return options
    },
  },
}
</script>

<style lang="scss">
#page-battery-analysis {
  .hide-rate {
    visibility: hidden;
  }
  .analysis-loss {
    margin-top: 25px;
  }
}
</style>
